import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faArrowRight, 
  faChevronLeft, 
  faChevronRight,
  faRocket,
  faShield,
  faBolt,
  faComments,
  faHandshake,
  faLaptopCode,
  faCog
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowRight, 
  faChevronLeft, 
  faChevronRight,
  faRocket,
  faShield,
  faBolt,
  faComments,
  faHandshake,
  faLaptopCode,
  faCog
);
